import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import QRValidationComponent from "../../Components/Patrocinadores/QRValidationComponent";
import { Footer } from "../../Components/Footer/FooterComponent";

export const QRValidationPage = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <QRValidationComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}